import React, { memo } from 'react';

/**
 * Renders a responsive <picture> element, preferring webp sources.
 *
 * @param {Object} props
 * @param {string} [props.alt] - Alt text for the image.
 * @param {string} [props.className] - Class applied to the <img>.
 * @param {string[]} [props.sources] - Image source URLs (or base64 data URIs).
 */
const ImageComponent = ({ alt, className, sources = [], ...rest }) => {
  const sourcesElements = sources
    .sort((a) => {
      if (a.includes('webp')) {
        return -1;
      }
      return 1;
    })
    .map((source, i) => {
      const fileExtension = source.includes('base64')
        ? source.match(/data:image\/(.*?);base64,/)[1]
        : source.match(/\.[0-9a-z]+$/i)[0].replace('.', '');
      return <source key={i} srcSet={source} type={`image/${fileExtension}`} />;
    });

  return (
    <picture>
      {sourcesElements}
      <img alt={alt} className={className} {...rest} />
    </picture>
  );
};

const Image = memo(ImageComponent);

export default Image;
